<div
  [class]="containerClass"
  [attr.aria-label]="'Progresso: ' + normalizedProgress + '%'"
>
  <svg class="absolute inset-0 -rotate-90" viewBox="0 0 36 36" aria-hidden="true">
    <circle
      cx="18"
      cy="18"
      r="15"
      fill="none"
      stroke="currentColor"
      class="text-lWhite20"
      stroke-width="6"
    ></circle>

    <circle
      cx="18"
      cy="18"
      r="15"
      fill="none"
      stroke="currentColor"
      class="text-lPrimary"
      stroke-width="6"
      stroke-linecap="round"
      pathLength="100"
      [attr.stroke-dasharray]="normalizedProgress + ' 100'"
    ></circle>
  </svg>

  @if (showLabel) {
    <div [class]="labelClass">
      {{ normalizedProgress }}%
    </div>
  }
</div>